import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[escHandler]',
})
export class EscHandlerDirective {
  @Output()
  escHandler: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

  constructor() {}

  @HostListener('document:keyup', ['$event'])
  onKeyup(event: KeyboardEvent) {
    if ((event.which || event.keyCode) === 27) {
      this.escHandler.emit(event);
    }
  }
}
